<template>
  <div class="edit-caption-form">
    <!-- Header -->
    <div class="header edit-caption-form__header">
      <div class="header__back-link-wrap">
        <LinkWithIcon class="header__back-link" @click="emit('cancel')" isDottedUnderline>
          <template #icon><IconEmbedded name="arrow-left_2-5" :size="16" /></template>
          <span>Back</span>
        </LinkWithIcon>
      </div>

      <h1 class="global-h1 header__title">Edit Caption</h1>

      <!-- Limit warning -->
      <div v-if="isAtLimit" class="limit-warning edit-caption-form__limit-warning">Caption limit reached (max {{ MAX_CAPTION_LENGTH }} characters)</div>
      <!-- / Limit warning -->

      <textarea class="global-textarea edit-caption-form__textarea" :disabled="isSaving" v-model="_captionText" :maxlength="MAX_CAPTION_LENGTH"></textarea>
    </div>
    <!-- / Header -->
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from "vue";

// Components
import LinkWithIcon from "@components/LinkWithIcon.vue";
import IconEmbedded from "@components/ui/IconEmbedded.vue";

// Constants
import { MAX_CAPTION_LENGTH } from "@/constants/social";

const props = withDefaults(
  defineProps<{
    captionText: string;
    saveCallBack: Function;
  }>(),
  {
    captionText: "",
    saveCallBack: () => {},
  }
);

const emit = defineEmits<{
  (e: "save", newCaptionText: string): void;
  (e: "cancel"): void;
}>();

// Local caption copy =========================================================
const _captionText = ref<string>("");

onMounted(() => (_captionText.value = props.captionText));

// Caption limit ==============================================================
const isAtLimit = computed(() => _captionText.value.length >= MAX_CAPTION_LENGTH);

// Save =======================================================================
const isSaving = ref<boolean>(false);

async function save() {
  if (props.saveCallBack) {
    isSaving.value = true;
    await props.saveCallBack(_captionText.value);
    isSaving.value = false;
  }
  emit("save", _captionText.value);
}

// Define expose ==============================================================
defineExpose({
  save,
  cancel: () => emit("cancel"),
});
</script>

<style scoped lang="scss">
// Limit warning ==============================================================
.limit-warning {
  padding: 12px 16px;
  margin-bottom: 20px;
  background: rgba(255, 193, 7, 0.15);
  border: 1px solid rgba(255, 193, 7, 0.6);
  border-radius: 6px;
  color: #856404;
  font-weight: 600;
  text-align: center;
}

// Header =====================================================================
.header {
  &__back-link-wrap {
    padding-bottom: 15px;
    margin-bottom: 20px;
    border-bottom: 1px rgba(0, 0, 0, 0.15) solid;
  }

  &__back-link {
  }

  &__title {
    margin-bottom: 10px;
  }

  &__subtitle {
  }
}

// Edit caption form ==========================================================
.edit-caption-form {
  &__header {
  }

  &__textarea {
    min-height: 180px;
  }
}
</style>
